export const languageStringsContact = {
  title: "Contact information",
  basic: {
    title: "Basic information",
    accountType: "Account type",
    personal: "Personal",
    business: "Business",
    name: "First Name",
    surname: "Last Name",
    phone: "Phone Number",
    dic: "VAT ID",
    ico: "Company ID",
    companyName: "Company Name",
  },
  address: {
    title: "Address",
    street: "Street and No.",
    city: "City",
    zip: "ZIP Code",
    country: "Country",
    state: "State",
    czechRepublic: "Czech Republic",
    slovakia: "Slovakia",
    hungary: "Hungary",
    polish: "Poland",
  },
};
